<template>
  <div>
    <v-container fluid ref="container">
      <p>
        <span class="affiliate-label">Contact name</span> {{ item.data && item.data.contact_user_name }}
        <span class="smaller-font">{{item.data.contact_user_id}}</span>
        <br>
        <span class="thread-label">ChatID</span> {{ item.data && item.data.id }}
      </p>

      <v-card-title>
      </v-card-title>

      <v-card-text>
        <div class="message-container" ref="messagesList">
          <ul class="messages-list">
            <v-btn v-if="item.data && item.data.messages && item.data.messages.length > displayedMessagesCount" @click="showMoreMessages">Show previous 10 messages</v-btn>
              <li
                  v-for="message in (item.data && item.data.messages ? item.data.messages.slice(-displayedMessagesCount) : [])"
                  :key="message.message_id"
                  :class="getMessageClass(message)"
              >
              <div class="message-content" @click="handleMessageClick(message, item.data.id)">{{ message.message }}</div>


              <div v-if="message.attachments && message.attachments.length">
                <div class="attachments-list">
                  <a
                      v-for="attachment in message.attachments"
                      :key="attachment.attachment_name"
                      :href="attachment.url"
                      target="_blank"
                      style="display: block; font-weight: bold; font-size: 1.1em; text-decoration: none; color: #333; padding: 5px 10px; background-color: #f4f4f4; margin-bottom: 5px; border-radius: 5px; transition: color 0.3s;"
                      @mouseover="hover = true"
                      @mouseleave="hover = false"
                      :style="hover ? {color: '#007BFF'} : {}"
                  >
                    {{ attachment.name }}
                  </a>
                </div>
              </div>

              <div class="message-sender">
                {{ getSenderName(message) }}
                <span :style="getReadStatus(message).style">{{ getReadStatus(message).status }}</span>
              </div>
            </li>
          </ul>
        </div>
      </v-card-text>

      <v-card-actions>
        <div class="input-container">
          <div class="input-and-file-container">
            <div class="flex-container">
              <v-text-field
                  v-model="newMessage"
                  label="New message"
                  class="message-input"
                  :append-outer-icon="uploadStatusIcon"
                  @click:append-outer="onUploadClick"
              ></v-text-field>
              <div v-if="attachmentFileName" class="attachment-info">
                <span class="attachment-label">Attachment file name</span>
                <span class="attachment-filename">{{attachmentFileName}}</span>
              </div>
            </div>


            <div class="file-upload-info">
              <div class="file-icon">
                <v-icon v-if="selectedFile">mdi-paperclip</v-icon>
              </div>
              <div class="file-name-display" v-if="selectedFile">{{ selectedFile.name }}</div>
            </div>
          </div>

          <v-file-input
              v-model="selectedFile"
              @change="handleFileUpload"
              class="hidden-file-input"
              ref="fileInput"
              style="display: none;"
          ></v-file-input>

          <v-btn @click="sendMessage" color="primary" class="send-button" :disabled="!newMessage.trim()">Send</v-btn>
        </div>
      </v-card-actions>

    </v-container>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";
import store from "@/store";
import axios from 'axios'

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      newMessage: '',
      selectedFile: null,
      presignedUrl: '',
      uploadStatus: null,
      attachments: [],
      hover: false,
      threadId: null,
      displayedMessagesCount: 10,
      shouldScrollToBottom: true,
      attachmentFileName: null,
    };
  },
  mounted() {
    this.scrollToBottom();
  },
  // beforeUpdate() {
  //   this.scrollToBottom();
  // },
  created() {
    if (this.item.data && this.item.data.messages) {
      this.item.data.messages.forEach((message) => {
        this.clearNewThreadMessages(message.message_id);
      });
    }
  },
  methods: {
    ...mapMutations('messages', ['clearNewThreadMessages', 'setNewThreadMessages']),
    showMoreMessages() {
      this.displayedMessagesCount += 10;
      this.shouldScrollToBottom = false;
    },
    async handleMessageClick(message, threadId) {

      setTimeout(async () => {
        const lastMessage = this.item.data.messages[this.item.data.messages.length - 1];

        console.log(`Clicked message this.threadId-${threadId}: lastMessage-${JSON.stringify(lastMessage)}` );
        if (lastMessage.author_type === 'affiliate'
            && lastMessage.recipient_read === null
        ) {
          await this.markThreadAsRead(threadId);
          message.isRead = true
          await this.setNewThreadMessages(message)
          this.item.data.messages.forEach((message) => {
            if (message.recipient_read === null) {
              message.recipient_read = new Date().getTime() / 1000
            }
          });
        }
      }, 100);
    },
    onUploadClick() {
      this.$nextTick(() => {
        if (this.$refs.fileInput && this.$refs.fileInput.$el) {
          this.$refs.fileInput.$el.querySelector('input').click();
        }
      });
    },
    hasDuplicateAttachmentName() {
      return this.item.data.messages.some((message) => {
        if (message.attachments) {
          return message.attachments.some((attachment) => {
            return attachment.name === this.selectedFile.name;
          });
        }
        return false;
      });
    },
    async handleFileUpload(event) {
      if (this.selectedFile) {
        this.uploadStatus = 'loading';
        await this.uploadFileToS3();
      }
    },

    async uploadFileToS3() {
      if (!this.selectedFile) return;

        try {
          if (this.hasDuplicateAttachmentName(this.item.data.messages)) {
            const userChoice = window.confirm(`File with this name ${this.selectedFile.name} already exists! Do you want to replace it? (OK to replace, Cancel to make a copy)`);

            // const userChoice = await this.$dialog.warning({
            //   title: `www.`,
            //   text: `File with this name ${this.selectedFile.name} already exists! Do you want to replace it? (OK to replace, Cancel to make a copy)`,
            //   className: 'custom-dialog',
            // })

            if (!userChoice) {
              let fileNameWithoutExtension = this.selectedFile.name.split('.').slice(0, -1).join('.');
              let fileExtension = this.selectedFile.name.split('.').pop();
              let copyNumber = 1;
              let newFileName = `${fileNameWithoutExtension}_copy${copyNumber}.${fileExtension}`;

              this.item.data.messages.forEach(message => {
                if (message.attachments) {
                  message.attachments.forEach(attachment => {
                    const match = attachment.name.match(new RegExp(`^${fileNameWithoutExtension}_copy(\\d+).${fileExtension}$`));
                    if (match && match[1]) {
                      const currentCopyNumber = parseInt(match[1], 10);
                      if (currentCopyNumber >= copyNumber) {
                        copyNumber = currentCopyNumber + 1;
                        newFileName = `${fileNameWithoutExtension}_copy${copyNumber}.${fileExtension}`;
                      }
                    }
                  });
                }
              });

              this.selectedFile = new File([this.selectedFile], newFileName, { type: this.selectedFile.type });

            }
          }

          this.attachments.push(this.selectedFile.name);

          await store.dispatch('messages/UPLOAD_ATTACHMENTS', {
            threadId: this.item.data.id,
            attachmentsUploads: this.attachments,
          });
          console.log("Attachments uploaded successfully!");

          console.log('this.getAttachments:',this.getAttachments);
          try {
            const uploadPromises = this.getAttachments.map(async (attachment) => {
              await axios.put(attachment.presignedURL, this.selectedFile, {
                headers: {
                  'Content-Type': this.selectedFile.type,
                },
              });
            });

            await Promise.all(uploadPromises);
            this.uploadStatus = 'success';
            this.attachmentFileName = this.selectedFile.name;
            this.selectedFile = null;
          } catch (error) {
            console.error('Error uploading attachments:', error);
            this.uploadStatus = 'failed';
            alert('Error uploading attachments to s3!');
          }

        } catch (error) {
          console.error("Error uploading attachments:", error);
          alert('Error uploading attachments!');
        }

    },
    scrollToBottom() {
      if (!this.shouldScrollToBottom) {
        return;
      }
      this.$nextTick(() => {

        const messagesList = this.$refs.messagesList;
        if (messagesList) {
          const isAtBottom = this.isScrolledToBottom();
          messagesList.scrollTop = messagesList.scrollHeight - messagesList.clientHeight;

          try {
            if (this.item.data.messages) {
              setTimeout(async () => {
                const lastMessage = this.item.data.messages[this.item.data.messages.length - 1];
                if (lastMessage.author_type ==='affiliate'
                    && lastMessage.recipient_read === null) {
                  await this.markThreadAsRead(this.item.data.id);
                  await store.dispatch('messages/FETCH_MESSAGES');
                }
              }, 100);
            }
          } catch (error) {
            console.error('Error in scrollToBottom:', error);
          }
        }
      });
    },
    getMessageClass(message) {
      return message.author_type === 'manager' ? 'other-message' : 'my-message';
    },
    getSenderName(message) {
      return message.author_type === 'manager' ? 'you' : message.author_name;
    },
    timeSince(date) {
      const seconds = Math.floor((new Date() - date) / 1000);

      let interval = seconds / 31536000;

      if (interval > 1) {
        return Math.floor(interval) + " years ago";
      }
      interval = seconds / 2592000;
      if (interval > 1) {
        return Math.floor(interval) + " months ago";
      }
      interval = seconds / 86400;
      if (interval > 1) {
        return Math.floor(interval) + " days ago";
      }
      interval = seconds / 3600;
      if (interval > 1) {
        return Math.floor(interval) + " hours ago";
      }
      interval = seconds / 60;
      if (interval > 1) {
        return Math.floor(interval) + " minutes ago";
      }
      return Math.floor(seconds) + " seconds ago";
    },
    getReadStatus(message) {
      if (message.author_type === 'manager') {
        if (message.recipient_read !== null) {
          const readDate = new Date(message.recipient_read * 1000);
          return {
            // status: `✓✓ ${this.timeSince(readDate)}`,
            status: `✓✓ Seen`,
            style: {
              color: 'green',
              fontWeight: 'bold'
            }
          };
        } else {
          return {
            status: '✓ Sent',
            style: {
              color: 'gray',
              fontWeight: 'bold'
            }
          };
        }
      }
      return {
        status: '',
        style: {}
      };
    },
    isScrolledToBottom() {
      if (this.$refs.messagesList) {
        const messagesList = this.$refs.messagesList;
        return messagesList.scrollTop >= messagesList.scrollHeight - messagesList.clientHeight;
      }
      return false;
    },
    formatDate(dateString) {
      const messageDate = new Date(dateString * 1000); // Convert Unix timestamp to JavaScript Date
      const now = new Date();

      const sameDay = now.getDate() === messageDate.getDate() && now.getMonth() === messageDate.getMonth() && now.getFullYear() === messageDate.getFullYear();
      const previousDay = now.getDate() - 1 === messageDate.getDate() && now.getMonth() === messageDate.getMonth() && now.getFullYear() === messageDate.getFullYear();

      if (sameDay) {
        return `Today, ${messageDate.getHours()}:${messageDate.getMinutes()}`;
      } else if (previousDay) {
        return `Yesterday, ${messageDate.getHours()}:${messageDate.getMinutes()}`;
      } else {
        return `${messageDate.getDate()}.${messageDate.getMonth()+1}.${messageDate.getFullYear()}, ${messageDate.getHours()}:${messageDate.getMinutes()}`;
      }
    },
    async markThreadAsRead(threadId) {
      const params = {
        threadId:  threadId,
        employeeId: this.user[0].employee_id,
      }
      await store.dispatch('messages/MARK_THREAD_AS_READ', params);
    },
    async sendMessage() {
      try {
        const attachments = this.attachments || [];
        const foundSender = this.affiliateManagers.find(item => item.email === this.user[0].email);
        let senderId = null;
        if (foundSender) {
          senderId = foundSender.id;
        }

        if (!this.item.data.id) {
          console.error('Invalid thread data or thread_id.');
          return;
        }
        let threadId = this.item.data.id;
        const params = {
          senderId:  senderId,
          threadId:  threadId,
          senderType: 'manager',
          recipientId: this.item.data.affiliate_id,
          recipientType: 'affiliate',
          message: this.newMessage,
          attachments: attachments,
          employeeId: this.user[0].employee_id,
        }
        await store.dispatch('messages/SEND_MESSAGE', params);

        this.newMessage = '';
        this.attachments = [];
        this.shouldScrollToBottom = true;
        this.attachmentFileName = null;
        this.scrollToBottom();
      } catch (error) {
        console.error('Error sending message:', error);
      }
    },

  },
  computed: {
    ...mapState('user', ['user']),
    ...mapState('managers', ['affiliateManagers']),
    ...mapGetters(
        'messages', ['getAttachments']
    ),
    uploadStatusIcon() {
      switch (this.uploadStatus) {
        case 'loading':
          return 'mdi-loading';
        case 'success':
          return 'mdi-check-circle';
        case 'error':
          return 'mdi-alert-circle';
        default:
          return this.selectedFile ? 'mdi-check-circle' : 'mdi-upload';
      }
    },
  },
};
</script>

<style scoped>

.message-input {
  width: 75%;
  border: none;
  padding: 10px;
  box-sizing: border-box;
  border-radius: 4px;
  margin-right: 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.send-button {
  background-color: #5c6bc0; /* This is a nice blue */
  color: white; /* Text color is white */
  border: none;
  padding: 10px 20px;
  cursor: pointer;
  border-radius: 4px;
  text-transform: uppercase; /* Makes the button text all caps */
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease; /* Adds a nice hover effect */
}

.send-button:hover {
  background-color: #3949ab; /* This is a darker blue */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.close-button {
  position: absolute;
  right: 10px;
  top: 10px;
  cursor: pointer;
}

.message-container {
  max-width: 80%;
  margin: 0 auto;
  padding: 10px;
  background-color: #f9f9f9; /* Light gray */
  border-radius: 15px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Add a subtle box shadow */
  height: 400px; /* or any other value */
  overflow: auto; /* allow scrolling */
}
.messages-list {
  list-style-type: none;
  margin: 0;
  padding: 0;
  min-width: 60%; /* Set a minimum width for your messages list */
}

.my-message,
.other-message {
  max-width: 70%;
  padding: 8px;
  border-radius: 15px;
  font-size: 16px;
  margin-bottom: 10px;
}

.my-message {
  background-color: #d4f0fd; /* Light blue */
  text-align: left;
  clear: both; /* Ensure proper message alignment */
}

.other-message {
  background-color: #e3f8e5; /* Light green */
  text-align: right;
  clear: both; /* Ensure proper message alignment */
}

.message-content {
  display: inline-block;
}

.message-sender {
  font-size: 12px;
  color: #999; /* Dark gray */
}

.message-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-start; /* Align the content at the top of the screen */
  align-items: center;
  height: 100vh;
}

.input-wrapper {
  width: 100%;
}

.input-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}

.input-field {
  flex: 1;
  margin-right: 10px;
}

.send-button {
  border-radius: 15px;
  align-self: flex-end;
}

/* Additional styles for the messages within the popup */
.message-container .my-message {
  background-color: #d4f0fd; /* Light blue - messages sent by you */
  color: #333; /* Dark gray text color for messages sent by you */
}

.message-container .other-message {
  background-color: #e3f8e5; /* Light green - messages sent by the user */
  color: #333; /* Dark gray text color for messages sent by the user */
}

/* Add hover styles for better user feedback */
.message-container .my-message:hover {
  background-color: #c2e2fa; /* Slightly darker blue on hover */
}

.message-container .other-message:hover {
  background-color: #d5f9e2; /* Slightly darker green on hover */
}

.scrollable-container {
  height: 100vh; /* adjust this to your liking */
  overflow-y: auto;
}

.affiliate-label, .thread-label {
  font-weight: bold;       /* Make the text bold */
  color: #2C3E50;          /* Dark blue color */
  margin-right: 5px;      /* Add some space to the right */
  background-color: #EAECEE; /* Light gray background */
  padding: 2px 5px;       /* Padding around the text */
  border-radius: 4px;     /* Rounded corners */
}

.v-icon.mdi-upload {
  color: #5c6bc0;
  font-size: 24px;
}
.input-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.input-and-file-container {
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-right: 10px;
}

.smaller-font {
  font-size: 0.8em;
}

.flex-container {
  display: flex;
  flex-direction: column;
}

.attachment-filename {
  margin-top: 8px;
  font-size: 14px;
  color: #555;
}

.attachment-info {
  padding: 0 8px;
}

.attachment-label, .attachment-filename {
  display: block;
}

.attachment-label {
  font-weight: bold;
  margin-bottom: 4px;
}

.attachment-filename {
  font-style: italic;
  color: #555;
}


</style>
